import { Component, Event, EventEmitter, h, Listen, Prop, State, Watch } from '@stencil/core';

@Component({
  tag: 'cr-toggle-list',
  styleUrl: 'cr-toggle-list.css',
  shadow: true,
})
export class CrToggleList {

  /**
   * Each item maps to an individual toggle
   * @type {Map<string, boolean>}
   */
  @Prop() items: Map<string, boolean> = new Map()

  /**
   * Emit changes to the toggle list
   * @type {EventEmitter<Map<string, boolean>>}
   */
  @Event() formchange: EventEmitter<Map<string, boolean>>

  @State() toggleables: Array<Array<any>> = []


  componentWillLoad() {
    this.updateToggleables()
  }

  @Watch('items')
  updateToggleables() {
    this.toggleables = Array.from(this.items.entries())
  }

  @Listen("bx-toggle-changed")
  handleToggleChanged(e) {
    e.preventDefault()
    e.stopPropagation()
    Array.from(this.toggles.entries()).forEach((entry) => {
      this.items.set(entry[0], entry[1].checked)
    })
    this.formchange.emit(this.items)
  }

  render() {
    return (
      <div class='container'>
      {
        this.toggleables.map((entry) => {
          const key: string = entry[0]
          const val: boolean = entry[1]
          const label: string = `${key.substring(0, 1).toUpperCase()}${key.substring(1)}`
          return (
            <bx-toggle
              ref={(el) => this.toggles.set(key, el)}
              checked-text={label}
              unchecked-text={label}
              checked={val}
            ></bx-toggle>
          )
        })
      }
      </div>
    );
  }


  private toggles: Map<string, HTMLInputElement> = new Map()

}
